import classNames from 'classnames'

import style from './style.scss'

export type Props = React.HTMLAttributes<HTMLHeadingElement>

function HeadlineTwo({ className, ...rest }: Props) {
  return <h2 className={classNames(style.wrapper, className)} {...rest} />
}

export default HeadlineTwo
